



































import Vue from 'vue'

import { Region } from '@/utils/interfaces'
import { getRegions } from '@/api/Address/address'
import CreateDialog from '@/components/CreateDialog.vue'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  props: {
    value: Boolean,
    multiple: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      regions: [] as Region[],
      selectedRegions: [] as boolean[],
      selectedRegion: null as Region | null,
      pendingRegions: [] as number[],
    }
  },
  methods: {
    onSuccess(): void {
      const newRegions: Region[] = []
      if (this.multiple) {
        this.selectedRegions.forEach((value, index) => {
          if (value) {
            newRegions.push(this.regions[index])
          }
        })
      } else if (this.selectedRegion) newRegions.push(this.selectedRegion)
      this.$emit('regions-selected', newRegions)
      this.$emit('input', false)
    },
    async setRegions(regions: number[]) {
      this.pendingRegions = regions
      if (this.regions.length) {
        this.updateRegions()
      }
    },
    updateRegions(): void {
      const newRegions = [] as Region[]
      this.regions.forEach((region, index) => {
        if (this.pendingRegions.includes(region.id)) {
          newRegions.push(region)
          this.selectedRegions[index] = true
          this.selectedRegion = region
        } else this.selectedRegions[index] = false
      })
      console.log('new regions', newRegions)
      this.$emit('regions-selected', newRegions)
    },
  },
  async created(): Promise<void> {
    const response = await getRegions({ limit: 100, country__name: 'Cuba' })
    this.regions = response.data.results

    if (this.pendingRegions.length) {
      this.updateRegions()
    }
  },
})
